import { Activity, MessageCircle, Loader2 } from 'lucide-react';
import { useDock } from '@/contexts/DockContext';
import { useJobs } from '@/contexts/JobsContext';

// One dock in the corner: Activity + Chat share a trigger and a drawer
export function UtilityDock() {
  const { tab, setTab, chatUnread } = useDock();
  const { activeCount, refresh } = useJobs();
  const btn = (id, Icon, badge, label, active) => (
    <button key={id} data-testid={id === 'activity' ? 'activity-panel-trigger' : 'chat-launcher'} title={label}
      onClick={() => { if (id === 'activity') refresh(); setTab(tab === id ? null : id); }}
      className={`relative w-11 h-11 rounded-full flex items-center justify-center transition-all ${tab === id ? 'bg-[#FF4500] text-white' : 'text-[#c8c8d0] hover:bg-white/10'}`}>
      {active ? <Loader2 className="w-5 h-5 animate-spin text-[#FF4500]" /> : <Icon className="w-5 h-5" />}
      {badge > 0 && <span data-testid={id === 'activity' ? 'activity-badge' : 'chat-unread-badge'} className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-white text-[#FF4500] text-[10px] font-bold flex items-center justify-center">{badge > 99 ? '99+' : badge}</span>}
    </button>
  );
  return (
    <div data-testid="utility-dock" className="fixed z-[60] right-4 bottom-24 md:bottom-6 flex items-center gap-1 p-1 rounded-full bg-[#1A1A20]/95 backdrop-blur border border-white/10 shadow-xl">
      {btn('activity', Activity, activeCount, 'Activity', activeCount > 0 && tab !== 'activity')}
      <span className="w-px h-6 bg-white/10" />
      {btn('chat', MessageCircle, chatUnread, 'Chat', false)}
    </div>
  );
}

// Tabs shown at the top of both drawers so users can flip between them
export function DockTabs() {
  const { tab, setTab } = useDock();
  return (
    <div className="flex gap-0.5 p-0.5 rounded-lg bg-white/[0.04] border border-white/[0.06]" data-testid="dock-tabs">
      {[{ id: 'activity', l: 'Activity' }, { id: 'chat', l: 'Chat' }].map(t => (
        <button key={t.id} data-testid={`dock-tab-${t.id}`} onClick={() => setTab(t.id)} className={`px-2.5 py-1 rounded-md text-[11px] font-medium ${tab === t.id ? 'bg-[#FF4500] text-white' : 'text-[#8A8A93] hover:text-white'}`}>{t.l}</button>
      ))}
    </div>
  );
}
